import Axios  from "axios"

export const getLabors = (labors) => async (dispatch) => {
    dispatch({
        type: 'LABOR_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/labor/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'LABORS_GET_SUCCESS',
                payload: data.labors
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'LABOR_ERROR'           
        })         
    }
}

export const getLaborDetail = (labor) => async (dispatch) => {
    dispatch({
        type: 'LABOR_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/labor/get/'+ labor, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'LABOR_GET_DETAIL_SUCCESS',
                payload: data.labor
            })             
        }

    } catch (error) {
        dispatch({
            type: 'LABOR_ERROR'           
        })         
    }
}

export const getLaborsByCrop = (crop) => async (dispatch) => {
    dispatch({
        type: 'LABOR_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/labor/getbycrop/'+ crop, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'LABORS_BY_CROP_SUCCESS',
                payload: data.labors
            })             
        }

    } catch (error) {
        dispatch({
            type: 'LABOR_ERROR'           
        })         
    }
}

export const addLabor = (name, description, cropslist, require_machinery, image) => async (dispatch) => {
    dispatch({
        type: 'LABOR_LOADING'
    })
    try {
        let imagen
        if(image !== null && image !== undefined && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            imagen = data
        }else{
            imagen = image
        }

        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/labor/register', {
                name: name,
                description: description,
                require_machinery: require_machinery,
                crops: cropslist,
                image: imagen
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newLabor = {
                _id: data.id,
                name: name,
                description: description,
                require_machinery: require_machinery,
                crops: cropslist,
                image: imagen
            }
            dispatch({
                type: 'LABOR_ADD_SUCCESS',
                payload: newLabor
            })
        }
    } catch (error) {
        dispatch({
            type: 'LABOR_FAIL'
        })
    }
}

export const editLabor = (name, description, cropslist, require_machinery, image, idLabor) => async (dispatch) => {
    dispatch({
        type: 'LABOR_LOADING'
    })
    try {
        let imagen
        if(image !== null && image !== undefined && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            imagen = data
        }else{
            imagen = image
        }

        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/labor/edit/' + idLabor, {
                name: name,
                description: description,
                crops: cropslist,
                require_machinery: require_machinery,
                image: imagen
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'LABOR_EDIT_SUCCESS',
            payload: {
                name: name,
                description: description,
                crops: cropslist,
                require_machinery: require_machinery,
                _id: idLabor
            }
        })
    } catch (error) {
        dispatch({
            type: 'LABOR_ERROR'
        })
    }
}

export const removeLabor = (idLabor) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/labor/remove/' + idLabor, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'LABOR_DELETE_SUCCESS',
                payload: {
                    idLabor: idLabor,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'LABOR_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'LABOR_ERROR'
        })
    }
}